<button
	type="button"
	class="btn btn-transparent text-white position-relative"
	ngbTooltip="FUNCTIONALITY NOT YET IMPLEMENTED"
>
	<i class="bi bi-bell-fill fs-6"></i>
	<!--	<span class="position-absolute translate-middle badge rounded-pill bg-danger custom-badge">-->
	<!--		99+-->
	<!--		<span class="visually-hidden">unread messages</span>-->
	<!--	</span>-->
</button>
